export const ItemsView = (props: any) => {

    return (
        <>
        vista de items
        </>
    )
}